// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"styles_btnWrapper__VTGoz","btn":"styles_btn__TG5dw","spin":"styles_spin__3Bfx2"};